
<div class="wrapper">
    <app-header></app-header>

    <!-- content start -->
    <section class="content store-content">
        <!-- desktop version -->
        <div class="store-banner-desk d-none d-lg-flex">
            <div class="container">
                <div class="row clearfix">
                    <div class="col-lg-8">
                        <a href="javasript:;" (click)="goBack()" class="go-back"></a>
                        <h2 class="store-title" *ngIf="storeDetails?.displayName">
                            {{ storeDetails.displayName
                            }}<a href="javascript:;" class="share-icon" (click)="share()"></a>
                        </h2>
                        <div class="rate-bx" *ngIf="getAverageRating()!==0">
                            <span class="google-icon">
                                <img src="./assets/images/google-icon.png" width="100%" height="auto" alt="Google"
                                    loading="lazy" />
                            </span>
                            <star-rating style="transform: scale(.9);" #star1 [value]="getAverageRating()"
                                [totalstars]="5" checkedcolor="#F2C94C" uncheckedcolor="#dddddd" size="24px"
                                [readonly]="true"></star-rating>
                            <div class="rate-txt ml-2">
                                {{ storeDetails.avg_rating }}
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4"> 
                        <div class="button-group" *ngIf="storeDetails?.phoneNumber">
                            <a *ngIf="storeDetails?.phoneNumber" href="tel:{{ storeDetails.phoneNumber }}"
                                class="button-blue-rd tel-but">{{ storeDetails.phoneNumber }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- desktop version -->

        <!-- mobile version -->
        <div class="store-details-section d-block d-lg-none">
            <div class="container">
                <div class="clearfix" *ngIf="storeDetails?.displayName">
                    <span class="store-name"><strong> {{ storeDetails?.displayName }}</strong>
                        <a href="javascript:;" (click)="goBack()" class="back-arrow"></a>
                    </span>
                    <a href="javascript:;" (click)="share()" class="share-but float-right">{{
                        "store-listing.share"
                        | translate
                        }}</a>
                </div>
                <h6 class="store-title-txt mob">
                    {{
                    "store-listing.store-site.store-details.title"
                    | translate
                    }}
                </h6>
                <span class="plus-code-txt" *ngIf="storeDetails?.gplusCode">
                    <a href="https://plus.codes/{{ storeDetails?.gplusCode }}" target="_blank" Style="color:#1B2B81">
                        <strong>{{
                            "store-listing.store-site.store-details.details.plus-code"
                            | translate
                            }}
                            :
                            {{
                            storeDetails?.gplusCode
                            }}</strong>
                    </a>
                </span>
                <div class="store-open-close my-3" *ngIf="storeDetails?.timings">
                    <span class="store-status open-icon"></span>
                    <strong class="timing-txt" style="line-height: 20px">
                        {{
                        "store-listing.store-card.business-hours"
                        | translate
                        }}
                        -
                        {{
                        utility.getTodayStoreTimings(storeDetails?.timings)
                        }}
                    </strong>
                  
                </div>
                <div class="mt-3 mb-4" *ngIf="storeDetails?.tmp_Message">
                    <span class="temp_msg_store">
                        {{ storeDetails?.tmp_Message }}</span>
                </div>
                <div class="store-add-photo clearfix address-txt" *ngIf="storeDetails?.address">
                    <address *ngIf="storeDetails?.address">
                        {{ storeDetails?.address }}<br />{{
                        storeDetails.city ? storeDetails?.city?.name : ""
                        }}
                        {{
                        storeDetails.state
                        ? "," + storeDetails?.state?.name
                        : ""
                        }}
                    </address>
                    <div class="store-photo store-photo-desk">
                        <div id="storeImagesPlaceHolder1" class="row"></div>
                        <span id="seePhotos1" class="see-photos-txt"></span>
                    </div>
                </div>
                <div class="mt-3 mb-4" class="store-add-photo clearfix landmark-txt" *ngIf="storeDetails?.landmark">

                    <address [innerHtml]="storeDetails.landmark"></address>
                </div>
                <div class="button-group">
                   
                    <a *ngIf="storeDetails?.phoneNumber" href="tel:{{ storeDetails.phoneNumber }}"
                        class="call-store-but showCallScreen">{{
                        "store-listing.store-card.call-store" | translate
                        }}</a>
                </div>
                <div class="text-center">
                    <span class="get-direction get-direction-icon-mob"><a *ngIf="storeDetails?.gmapLink"
                            href="{{ storeDetails.gmapLink }}">{{
                            "store-listing.store-card.link-get-directions"
                            | translate
                            }}</a></span>

                    <!-- <span class="distance-txt">1.2 km away</span> -->
                    <span class="parking-txt-mob" *ngIf="storeDetails?.parkingAvailable">Parking Available</span>
                    <span class="address-txt" style="display: inline-block" *ngIf="storeDetails?.gmbLink"><a
                            href="{{ storeDetails?.gmbLink }}" Style="color:#1B2B81">{{
                            "store-listing.store-site.store-details.details.find-us-on-google"
                            | translate
                            }}</a></span>

                    <span class="review-txt" style="display: inline-block; margin-left: 8px"
                        *ngIf="storeDetails?.gmbReviewUrl">
                        <a href="{{ storeDetails.gmbReviewUrl }}" target="_blank" Style="color:#1B2B81">{{
                            "store-listing.store-site.store-details.details.review-us"
                            | translate
                            }}</a>
                    </span>
                </div>
            </div>
        </div>
        <!-- mobile version -->

        <div class="container">
            <div class="row pad-top-btm clearfix justify-content-center">
                <div class="col-lg-4 d-none d-lg-block border-right">
                    <h6 class="store-title-txt">
                        {{
                        "store-listing.store-site.store-details.title"
                        | translate
                        }}
                    </h6>
                    <div class="store-details-section store-det-desk" style="padding: 0px">
                        <span class="plus-code-txt">
                            <a *ngIf="storeDetails?.gplusCode" href="https://plus.codes/{{
                                    storeDetails.gplusCode
                                }}" target="_blank" Style="color:#1B2B81">
                                <strong>{{
                                    "store-listing.store-site.store-details.details.plus-code"
                                    | translate
                                    }}
                                    :
                                    {{
                                    storeDetails?.gplusCode
                                    }}</strong>
                            </a>
                        </span>

                        <div class="store-open-close" *ngIf="storeDetails?.timings">
                            <span class="store-status open-icon"></span>
                            <strong class="timing-txt" style="line-height: 20px">
                                {{
                                "store-listing.store-card.business-hours"
                                | translate
                                }}
                                -
                                {{
                                utility.getTodayStoreTimings(
                                storeDetails?.timings
                                )
                                }}
                            </strong>
                         
                        </div>
                       
                        <span class="address-txt" *ngIf="storeDetails?.address">{{ storeDetails.address }}<br />{{
                            storeDetails.city ? storeDetails.city.name : ""
                            }}
                            {{
                            storeDetails.state
                            ? "," + storeDetails.state.name
                            : ""
                            }}</span>
                        <span class="landmark-txt" *ngIf="storeDetails?.landmark" [innerHtml]="storeDetails.landmark">
                        </span>

                        <a *ngIf="storeDetails?.gmapLink" href="{{ storeDetails.gmapLink }}" target="_blank"
                            class="get-direction get-direction-icon pb-3">{{
                            "store-listing.store-card.link-get-directions"
                            | translate
                            }}</a>
                        <span class="parking-txt" *ngIf="storeDetails?.parkingAvailable"
                            style="margin-bottom: 10px">Parking Available</span>
                        <span class="address-txt" *ngIf="storeDetails?.gmbMapUrl">
                            <a href="{{ storeDetails.gmbMapUrl }}" target="_blank" Style="color:#1B2B81">{{
                                "store-listing.store-site.store-details.details.find-us-on-google"
                                | translate
                                }}</a>
                        </span>
                        <span class="review-txt" *ngIf="storeDetails?.gmbReviewUrl">
                            <a href="{{ storeDetails.gmbReviewUrl }}" target="_blank" Style="color:#1B2B81">{{
                                "store-listing.store-site.store-details.details.review-us"
                                | translate
                                }}</a>
                        </span>
                    </div>
                </div>

                <div class="col-lg-4 prod-ava-border" [ngClass]="{ 'border-right': hasStoreImages }">
                    <div class="product-available-bx product-avail-desk">
                        <h6>
                            {{
                            "store-listing.store-site.products-available.title"
                            | translate
                            }}
                        </h6>
                        <div>
                            <div class="prod-ava-thumb clearfix">
                                <ul>
                                    <li [ngClass]="PC == true ? '' : 'active'">
                                        <a href="javascript:;" style="cursor: default">
                                            <span class="product-icon pc-icon">
                                                <img src="./assets/images/pc_icon.svg" loading="lazy" />
                                            </span>
                                            <span class="product-txt">PC</span>
                                        </a>
                                    </li>
                                    <li [ngClass]="
                                            SmartPhone == true ? '' : 'active'
                                        ">
                                        <a href="javascript:;" style="cursor: default">
                                            <span class="product-icon phone-icon">
                                                <img style="    transform: scale(0.85);"
                                                    src="./assets/images/phone-icon.svg" loading="lazy" />
                                            </span>
                                            <span class="product-txt">Smartphone</span>
                                        </a>
                                    </li>
                                    <li [ngClass]="Tabs == true ? '' : 'active'">
                                        <a href="javascript:;" style="cursor: default">
                                            <span class="product-icon tablet-icon">
                                                <img src="./assets/images/tablet_icon.svg" loading="lazy" />
                                            </span>
                                            <span class="product-txt">Tablet</span>
                                        </a>
                                    </li>
                                    <li [ngClass]="
                                            Enterprise == true ? '' : 'active'
                                        ">
                                        <a href="javascript:;" style="cursor: default">
                                            <span class="product-icon enterprise-icon">
                                                <img src="./assets/images/enterprise_icon.svg" loading="lazy" />
                                            </span>
                                            <span class="product-txt">Enterprise</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div>
                                <div>
                                    <div class="view-store-offer-bx" *ngIf="storeDetails?.offers">
                                        <div class="inner-cont">
                                            <div class="title-section" (click)="
                                                    showStoreOffers($event)
                                                ">
                                                <h4 class="icon">
                                                    View Store Offers
                                                </h4>
                                                <span class="plus-icon">+</span>
                                            </div>
                                            <div class="cont-section" *ngIf="dealer && dealer.offers">
                                                <div class="card-offer" *ngFor="
                                                        let offer of dealer.offers
                                                    ">
                                                    <span class="card-txt">{{ offer.title }}
                                                        <strong>{{
                                                            offer.description
                                                            }}</strong></span>
                                                    <span class="card-txt">For offer redemption,
                                                        machine eligibility,
                                                        T&Cs <br />etc
                                                        <a href="/redeem">click here</a></span>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>

                                    <div class="product-details-bx">
                                        <span class="prod-det-txt price-icon" *ngIf="storeDetails?.priceRange">Price
                                            Range -
                                            {{ storeDetails.priceRange }}</span>
                                        <span class="prod-det-txt emi-icon" *ngIf="storeDetails?.emiAvailable">EMI
                                            Available</span>
                                        <span class="prod-det-txt payment-icon" *ngIf="
                                                storeDetails?.PaymentOptions
                                                    .length > 0
                                            ">Payment Methods -
                                            <span *ngFor="
                                                    let item of storeDetails.PaymentOptions
                                                ">
                                                | {{ item.name }}
                                            </span>
                                            
                                        </span>
                                        <span class="prod-det-txt mail-icon" *ngIf="
                                                storeDetails?.email &&
                                                storeDetails?.email.trim()
                                                    .length > 0
                                            ">
                                            <a href="mailto:{{
                                                    storeDetails.email
                                                }}">{{ storeDetails.email }}</a></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 d-none d-lg-block" *ngIf="
                        storeDetails?.partnerImages &&
                        storeDetails?.partnerImages.length > 0
                    ">
                    <h6 class="store-title-txt">
                        {{
                        "store-listing.store-site.store-images.title"
                        | translate
                        }}
                    </h6>
                    <div class="store-photo store-photo-desk">
                        <div id="storeImagesPlaceHolder2" class="row"></div>
                        <!-- <div class="row mb-3">
                            <div class="col-12">
                                <a href="./assets/images/store-img1.jpg" data-fancybox="gallery">
                                    <img src="./assets/images/store-img1.jpg" width="100%" height="auto" alt=""
                                        class="img-fluid">
                                </a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <a href="./assets/images/store-img2.jpg" data-fancybox="gallery">
                                    <img src="./assets/images/store-img2.jpg" width="100%" height="auto" alt=""
                                        class="img-fluid">
                                </a>
                            </div>
                            <div class="col-6">
                                <a href="./assets/images/store-img1.jpg" data-fancybox="gallery">
                                    <img src="./assets/images/store-img1.jpg" width="100%" height="auto" alt=""
                                        class="img-fluid">
                                </a>
                            </div> -->
                        <span id="seePhotos2" class="see-photos-txt"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="store-photo store-photo-desk d-none" *ngIf="
                storeDetails?.partnerImages &&
                storeDetails?.partnerImages.length > 0
            ">
            <h6 class="store-title-txt">
                {{ "store-listing.store-site.store-images.title" | translate }}
            </h6>
            <div id="storeImagesPlaceHolder1" class="row"></div>
            <span id="seePhotos1" class="see-photos-txt"></span>
        </div>

        <div class="section-bg-color form-gallery-row">
            <div class="container">
                <div class="row clearfix">
                    <div *ngIf="
                            storeDetails &&
                                storeDetails.sellertype &&
                                storeDetails.sellertype !== 'Reseller' &&
                                storeDetails?.FeaturedProducts &&
                                storeDetails?.FeaturedProducts.length == 0 &&
                                storeDetails?.reviews &&
                                storeDetails?.reviews.length == 0;
                            else GETACALL
                        ">
                        <div class="col-md-12">
                            Here
                            <div class="get-call-bx">
                                <div class="get-call-cont get-call-hor">
                                    <h2 class="section-title">
                                        {{
                                        "store-listing.store-site.get-a-call.title"
                                        | translate
                                        }}
                                    </h2>

                                    <form class="main-form clearfix" [formGroup]="getaCallForm"
                                        (ngSubmit)="submitDetails(mymodal)">
                                        <ul class="d-flex">
                                            <li>
                                                <div class="white-container name-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-name"
                                                        | translate
                                                        }}</label>
                                                    <input type="text" value="" placeholder="" class="textbox"
                                                        maxlength="50" formControlName="name" required />
                                                </div>
                                                <div *ngIf="
                                                        (f.name.touched &&
                                                            f.name.errors) ||
                                                        nameRequired
                                                    " class="errMsg err">
                                                    <div *ngIf="f.name.errors" style="font-size: 13px;">
                                                        Name is required
                                                    </div>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="white-container email-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-email"
                                                        | translate
                                                        }}</label>
                                                    <input type="email" value="" placeholder="" (blur)="validMail()"
                                                        formControlName="email" maxlength="50" class="textbox"
                                                        required />
                                                </div>
                                                <div *ngIf="emailRequired || (f.email.touched && f.email.errors)"
                                                    class="errMsg">
                                                    <div *ngIf="f.email.errors?.required" style="font-size: 13px;">Email
                                                        is required</div>
                                                    <div *ngIf="f.email.errors?.pattern" style="font-size: 13px;">Email
                                                        must be a valid email address</div>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="white-container mobile-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-mobile"
                                                        | translate
                                                        }}</label>
                                                    <input type="tel" value="" placeholder="" class="textbox"
                                                        (keypress)="
                                                            numberOnly($event)
                                                        " (keyup)="
                                                            numberMobile($event)
                                                        " formControlName="mobile" required />
                                                </div>
                                                <div *ngIf="
                                                        (f.mobile.touched &&
                                                            f.mobile.errors) ||
                                                        mobileRequired
                                                    " class="errMsg err2 mt-15">
                                                    <div *ngIf="f.mobile.errors" style="font-size: 13px;">
                                                        Mobile Number is
                                                        required
                                                    </div>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="white-container pincode-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-pincode"
                                                        | translate
                                                        }}</label>
                                                    <input type="text" value="" placeholder="" class="textbox"
                                                        (keypress)="
                                                            numberOnly($event)
                                                        " maxlength="6" formControlName="pincode" required />
                                                </div>
                                                <div *ngIf="
                                                        (f.pincode.touched &&
                                                            f.pincode.errors) ||
                                                        pincodeRequired
                                                    " class="errMsg err3 mt-15">
                                                    <div *ngIf="f.pincode.errors" style="font-size: 13px;">
                                                        Pin Code is required
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>

                                                <div class="get-a-call-subscribe mt-3">
                                                    <input type="checkbox" id="mandated" [(ngModel)]="mandate"
                                                        [ngModelOptions]="{standalone:true}" name="vehicle1"
                                                        value="Bike" class="form-check-input" />
                                                    <label for="mandated" formControlName="mandate"
                                                        class="form-check-label">
                                                        I understand Lenovo {{this.appComp.tenantContent.country_name}}
                                                        will pass my contact information to a Lenovo Authorized Reseller
                                                        to contact me for this promotional offer . </label>

                                                </div>
                                                <div *ngIf="(f.mandate.touched &&
                                                    f.mandate.errors) || mandaterequired" class="errMsg err4 mt-15">
                                                    <div class="mandreq" *ngIf="!mandate">
                                                        Please tick the checkbox to proceed
                                                    </div>
                                                </div>
                                                <div class="get-a-call-subscribe mt-3">
                                                    <input type="checkbox" id="subscribe" [(ngModel)]="consent"
                                                        [ngModelOptions]="{standalone: true}" name="vehicle1"
                                                        value="Bike" class="form-check-input" />
                                                    <label for="subscribe" class="form-check-label">
                                                        I want to receive marketing communications from Lenovo in
                                                        accordance with Lenovo’s
                                                        <ng-container *ngIf="hasPrivacyPolicy(appComp.tenantContent)">
                                                            <a [href]="getPrivacyPolicy(appComp.tenantContent)"
                                                                target="_blank">Lenovo Privacy
                                                                Policy</a></ng-container>
                                                        You may unsubscribe anytime using the link in each email
                                                        communication.
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <button type="submit"
                                                    class="submit-but call-store-but">{{"store-listing.submit" |
                                                    translate}}</button>
                                            </li>
                                        </ul>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-template #GETACALL> </ng-template>
                    <ng-container *ngIf="
                            storeDetails?.reviews &&
                            storeDetails?.reviews.length > 0 &&
                            storeDetails &&
                            storeDetails.sellertype &&
                            storeDetails.sellertype !== 'Reseller' &&
                            storeDetails?.FeaturedProducts &&
                            storeDetails?.FeaturedProducts.length == 0
                        ">
                        <div class="col-md-12">
                            <div class="review-bx mb-5">
                                <h2 class="section-title" *ngIf="
                                        storeDetails &&
                                        storeDetails.avg_rating &&
                                        storeDetails.avg_rating.length > 0
                                    ">
                                    Google Business Reviews
                                </h2>
                                <div class="stars" style="
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                    " *ngIf="
                                        storeDetails &&
                                        storeDetails.avg_rating &&
                                        storeDetails.avg_rating.length > 0
                                    ">
                                    <span class="rating">{{
                                        storeDetails.avg_rating
                                        }}</span>
                                    <star-rating style="transform: scale(0.8);" #star2 [value]="getAverageRating()"
                                        [totalstars]="5" checkedcolor="#F2C94C" class="gmbstars"
                                        [className]="'gmbstars'" uncheckedcolor="#9e9e9e" size="24px" [readonly]="true">
                                    </star-rating>
                                </div>
                                <div id="reviewsPlaceHolder" class="bx-wrapper"></div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="get-call-bx">
                                <div class="get-call-cont get-call-hor">
                                    <h2 class="section-title">
                                        {{
                                        "store-listing.store-site.get-a-call.title"
                                        | translate
                                        }}
                                    </h2>

                                    <form class="main-form clearfix" [formGroup]="getaCallForm"
                                        (ngSubmit)="submitDetails(mymodal)">
                                        <ul class="d-flex">
                                            <li>
                                                <div class="white-container name-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-name"
                                                        | translate
                                                        }}</label>
                                                    <input type="text" value="" placeholder="" class="textbox"
                                                        maxlength="50" formControlName="name" required />
                                                </div>
                                                <div *ngIf="
                                                        (f.name.touched &&
                                                            f.name.errors) ||
                                                        nameRequired
                                                    " class="errMsg err">
                                                    <div *ngIf="f.name.errors" style="font-size: 13px;">
                                                        Name is required
                                                    </div>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="white-container email-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-email"
                                                        | translate
                                                        }}</label>
                                                    <input type="email" value="" placeholder="" (blur)="validMail()"
                                                        formControlName="email" maxlength="50" class="textbox"
                                                        required />
                                                </div>
                                                <div *ngIf="emailRequired || (f.email.touched && f.email.errors)"
                                                    class="errMsg">
                                                    <div *ngIf="f.email.errors?.required" style="font-size: 13px;">Email
                                                        is required</div>
                                                    <div *ngIf="f.email.errors?.pattern" style="font-size: 13px;">Email
                                                        must be a valid email address</div>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="white-container mobile-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-mobile"
                                                        | translate
                                                        }}</label>
                                                    <input type="tel" value="" placeholder="" class="textbox"
                                                        (keypress)="
                                                            numberOnly($event)
                                                        " (keyup)="
                                                            numberMobile($event)
                                                        " formControlName="mobile" required />
                                                </div>
                                                <div *ngIf="
                                                        (f.mobile.touched &&
                                                            f.mobile.errors) ||
                                                        mobileRequired
                                                    " class="errMsg err2 mt-15">
                                                    <div *ngIf="f.mobile.errors" style="font-size: 13px;">
                                                        Mobile Number is
                                                        required
                                                    </div>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="white-container pincode-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-pincode"
                                                        | translate
                                                        }}</label>
                                                    <input type="text" value="" placeholder="" class="textbox"
                                                        (keypress)="
                                                            numberOnly($event)
                                                        " maxlength="6" formControlName="pincode" required />
                                                </div>
                                                <div *ngIf="
                                                        (f.pincode.touched &&
                                                            f.pincode.errors) ||
                                                        pincodeRequired
                                                    " class="errMsg err3 mt-15">
                                                    <div *ngIf="f.pincode.errors" style="font-size: 13px;">
                                                        Pin Code is required
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>

                                                <div class="get-a-call-subscribe mt-3">
                                                    <input type="checkbox" id="mandated" [(ngModel)]="mandate"
                                                        [ngModelOptions]="{standalone:true}" name="vehicle1"
                                                        value="Bike" class="form-check-input" />
                                                    <label for="mandated" formControlName="mandate"
                                                        class="form-check-label">
                                                        I understand Lenovo {{this.appComp.tenantContent.country_name}}
                                                        will pass my contact information to a Lenovo Authorized Reseller
                                                        to contact me for this promotional offer . </label>

                                                </div>
                                                <div *ngIf="(f.mandate.touched &&
                                                    f.mandate.errors) || mandaterequired" class="errMsg err4 mt-15">
                                                    <div class="mandreq" *ngIf="!mandate">
                                                        Please tick the checkbox to proceed
                                                    </div>
                                                </div>
                                                <div class="get-a-call-subscribe mt-3">
                                                    <input type="checkbox" id="subscribe" [(ngModel)]="consent"
                                                        [ngModelOptions]="{standalone: true}" name="vehicle1"
                                                        value="Bike" class="form-check-input" />
                                                    <label for="subscribe" class="form-check-label">
                                                        I want to receive marketing communications from Lenovo in
                                                        accordance with Lenovo’s
                                                        <ng-container *ngIf="hasPrivacyPolicy(appComp.tenantContent)">
                                                            <a [href]="getPrivacyPolicy(appComp.tenantContent)"
                                                                target="_blank">Lenovo Privacy
                                                                Policy</a></ng-container>
                                                        You may unsubscribe anytime using the link in each email
                                                        communication.
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <button type="submit"
                                                    class="submit-but call-store-but">{{"store-listing.submit" |
                                                    translate}}</button>
                                            </li>
                                        </ul>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="
                            storeDetails?.FeaturedProducts &&
                            storeDetails?.FeaturedProducts.length > 0 &&
                            storeDetails &&
                            storeDetails.sellertype &&
                            storeDetails.sellertype !== 'Reseller' &&
                            storeDetails?.reviews &&
                            storeDetails?.reviews.length == 0
                        ">
                        <div class="col-md-12">
                            <div id="featuredProductsPlaceHolder"></div>
                            <div class="get-call-bx">
                                <div class="get-call-cont get-call-hor">
                                    <h2 class="section-title">
                                        {{
                                        "store-listing.store-site.get-a-call.title"
                                        | translate
                                        }}
                                    </h2>

                                    <form class="main-form clearfix" [formGroup]="getaCallForm"
                                        (ngSubmit)="submitDetails(mymodal)">
                                        <ul class="d-flex">
                                            <li>
                                                <div class="white-container name-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-name"
                                                        | translate
                                                        }}</label>
                                                    <input type="text" value="" placeholder="" class="textbox"
                                                        maxlength="50" formControlName="name" required />
                                                </div>
                                                <div *ngIf="
                                                        (f.name.touched &&
                                                            f.name.errors) ||
                                                        nameRequired
                                                    " class="errMsg err">
                                                    <div *ngIf="f.name.errors" style="font-size: 13px;">
                                                        Name is required
                                                    </div>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="white-container email-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-email"
                                                        | translate
                                                        }}</label>
                                                    <input type="email" value="" placeholder="" (blur)="validMail()"
                                                        formControlName="email" maxlength="50" class="textbox"
                                                        required />
                                                </div>
                                                <div *ngIf="emailRequired || (f.email.touched && f.email.errors)"
                                                    class="errMsg">
                                                    <div *ngIf="f.email.errors?.required" style="font-size: 13px;">Email
                                                        is required</div>
                                                    <div *ngIf="f.email.errors?.pattern" style="font-size: 13px;">Email
                                                        must be a valid email address</div>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="white-container mobile-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-mobile"
                                                        | translate
                                                        }}</label>
                                                    <input type="tel" value="" placeholder="" class="textbox"
                                                        (keypress)="
                                                            numberOnly($event)
                                                        " (keyup)="
                                                            numberMobile($event)
                                                        " formControlName="mobile" required />
                                                </div>
                                                <div *ngIf="
                                                        (f.mobile.touched &&
                                                            f.mobile.errors) ||
                                                        mobileRequired
                                                    " class="errMsg err2 mt-15">
                                                    <div *ngIf="f.mobile.errors" style="font-size: 13px;">
                                                        Mobile Number is
                                                        required
                                                    </div>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="white-container pincode-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-pincode"
                                                        | translate
                                                        }}</label>
                                                    <input type="text" value="" placeholder="" class="textbox"
                                                        (keypress)="
                                                            numberOnly($event)
                                                        " maxlength="6" formControlName="pincode" required />
                                                </div>
                                                <div *ngIf="
                                                        (f.pincode.touched &&
                                                            f.pincode.errors) ||
                                                        pincodeRequired
                                                    " class="errMsg err3 mt-15">
                                                    <div *ngIf="f.pincode.errors" style="font-size: 13px;">
                                                        Pin Code is required
                                                    </div>
                                                </div>
                                            </li>


                                        </ul>
                                        <ul>
                                            <li>

                                                <div class="get-a-call-subscribe mt-3">
                                                    <input type="checkbox" id="mandated" [(ngModel)]="mandate"
                                                        [ngModelOptions]="{standalone:true}" name="vehicle1"
                                                        value="Bike" class="form-check-input" />
                                                    <label for="mandated" class="form-check-label">
                                                        I understand Lenovo {{this.appComp.tenantContent.country_name}}
                                                        will pass my contact information to a Lenovo Authorized Reseller
                                                        to contact me for this promotional offer. </label>

                                                </div>
                                                <div *ngIf="(f.mandate.touched &&
                                                f.mandate.errors)|| mandaterequired" class="errMsg err4 mt-15">
                                                    <div class="mandreq" *ngIf="!mandate">
                                                        Please tick the checkbox to proceed
                                                    </div>
                                                </div>
                                                <div class="get-a-call-subscribe mt-3">
                                                    <input type="checkbox" id="subscribe" [(ngModel)]="consent"
                                                        [ngModelOptions]="{standalone: true}" name="vehicle1"
                                                        value="Bike" class="form-check-input" />
                                                    <label for="subscribe" class="form-check-label">
                                                        I want to receive marketing communications from Lenovo in
                                                        accordance with Lenovo’s
                                                        <ng-container *ngIf="hasPrivacyPolicy(appComp.tenantContent)">
                                                            <a [href]="getPrivacyPolicy(appComp.tenantContent)"
                                                                target="_blank">Lenovo Privacy
                                                                Policy</a></ng-container>
                                                        You may unsubscribe anytime using the link in each email
                                                        communication.
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <button type="submit"
                                                    class="submit-but call-store-but">{{"store-listing.submit" |
                                                    translate}}</button>
                                            </li>
                                        </ul>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="
                            storeDetails?.FeaturedProducts &&
                            storeDetails?.FeaturedProducts.length > 0 &&
                            storeDetails &&
                            storeDetails.sellertype &&
                            storeDetails.sellertype === 'Reseller' &&
                            storeDetails?.reviews &&
                            storeDetails?.reviews.length > 0
                        ">
                        <div class="col-md-12">
                            <div *ngIf="
                                    storeDetails?.FeaturedProducts &&
                                    storeDetails?.FeaturedProducts.length > 0
                                " id="featuredProductsPlaceHolder"></div>
                            <div class="review-bx mb-5">
                                <h2 class="section-title" *ngIf="
                                        storeDetails &&
                                        storeDetails.avg_rating &&
                                        storeDetails.avg_rating.length > 0
                                    ">
                                    Google Business Reviews
                                </h2>
                                <div class="stars" style="
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                    " *ngIf="
                                        storeDetails &&
                                        storeDetails.avg_rating &&
                                        storeDetails.avg_rating.length > 0
                                    ">
                                    <span class="rating">{{
                                        storeDetails.avg_rating
                                        }}</span>
                                    <star-rating style="transform: scale(0.8);" #star2 [value]="getAverageRating()"
                                        [totalstars]="5" class="gmbstars" [className]="'gmbstars'"
                                        checkedcolor="#F2C94C" uncheckedcolor="#9e9e9e" size="24px" [readonly]="true">
                                    </star-rating>
                                </div>
                                <div id="reviewsPlaceHolder" class="bx-wrapper"></div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="
                            storeDetails?.FeaturedProducts &&
                            storeDetails?.FeaturedProducts.length > 0 &&
                            storeDetails &&
                            storeDetails.sellertype &&
                            storeDetails.sellertype !== 'Reseller' &&
                            storeDetails?.reviews &&
                            storeDetails?.reviews.length > 0
                        ">
                        <div class="col-md-4">
                            <div class="get-call-bx">
                                <div class="get-call-cont get-call-hor">
                                    <h2 class="section-title">
                                        {{
                                        "store-listing.store-site.get-a-call.title"
                                        | translate
                                        }}
                                    </h2>

                                    <form class="main-form clearfix" [formGroup]="getaCallForm"
                                        (ngSubmit)="submitDetails(mymodal)">
                                        <ul class="d-flex flex-column">
                                            <li>
                                                <div class="white-container name-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-name"
                                                        | translate
                                                        }}</label>
                                                    <input type="text" value="" placeholder="" class="textbox"
                                                        maxlength="50" formControlName="name" required />
                                                </div>
                                                <div *ngIf="
                                                        (f.name.touched &&
                                                            f.name.errors) ||
                                                        nameRequired
                                                    " class="errMsg">
                                                    <div *ngIf="f.name.errors" style="font-size: 13px;">
                                                        Name is required
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="white-container email-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-email"
                                                        | translate
                                                        }}</label>
                                                    <input type="email" value="" placeholder="" (blur)="validMail()"
                                                        formControlName="email" maxlength="50" class="textbox"
                                                        required />
                                                </div>

                                                <div *ngIf="emailRequired || (f.email.touched && f.email.errors)"
                                                    class="errMsg">
                                                    <div *ngIf="f.email.errors?.required" style="font-size: 13px;">Email
                                                        is required</div>
                                                    <div *ngIf="f.email.errors?.pattern" style="font-size: 13px;">Email
                                                        must be a valid email address</div>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="white-container mobile-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-mobile"
                                                        | translate
                                                        }}</label>
                                                    <input type="tel" value="" placeholder="" class="textbox"
                                                        (keypress)="
                                                            numberOnly($event)
                                                        " (keyup)="
                                                            numberMobile($event)
                                                        " formControlName="mobile" required />
                                                </div>
                                                <div *ngIf="
                                                        (f.mobile.touched &&
                                                            f.mobile.errors) ||
                                                        mobileRequired
                                                    " class="errMsg mt-15">
                                                    <div *ngIf="f.mobile.errors" style="font-size: 13px;">
                                                        Mobile Number is
                                                        required
                                                    </div>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="white-container pincode-icon">
                                                    <label>{{
                                                        "store-listing.store-site.get-a-call.form.label-pincode"
                                                        | translate
                                                        }}</label>
                                                    <input type="text" value="" placeholder="" class="textbox"
                                                        (keypress)="
                                                            numberOnly($event)
                                                        " maxlength="6" formControlName="pincode" required />
                                                </div>
                                                <div *ngIf="
                                                        (f.pincode.touched &&
                                                            f.pincode.errors) ||
                                                        pincodeRequired
                                                    " class="errMsg mt-15">
                                                    <div *ngIf="f.pincode.errors" style="font-size: 13px;">
                                                        Pin Code is required
                                                    </div>
                                                </div>
                                            </li>

                                            <li>

                                                <div class="get-a-call-subscribe mt-3">
                                                    <input type="checkbox" id="mandated" [(ngModel)]="mandate"
                                                        [ngModelOptions]="{standalone:true}" name="vehicle1"
                                                        value="Bike" class="form-check-input" />
                                                    <label for="mandated" formControlName="mandate"
                                                        class="form-check-label">
                                                        I understand Lenovo {{this.appComp.tenantContent.country_name}}
                                                        will pass my contact information to a Lenovo Authorized Reseller
                                                        to contact me for this promotional offer. </label>

                                                </div>
                                                <div *ngIf="(f.mandate.touched &&
                                                f.mandate.errors)|| mandaterequired" class="errMsg err4 mt-15">
                                                    <div class="mandrequired" *ngIf="!mandate">
                                                        Please tick the checkbox to proceed
                                                    </div>
                                                </div>
                                                <div class="get-a-call-subscribe mt-3">
                                                    <input type="checkbox" id="subscribe" [(ngModel)]="consent"
                                                        [ngModelOptions]="{standalone: true}" name="vehicle1"
                                                        value="Bike" class="form-check-input" />
                                                    <label for="subscribe" class="form-check-label">
                                                        I want to receive marketing communications from Lenovo in
                                                        accordance with Lenovo’s
                                                        <ng-container *ngIf="hasPrivacyPolicy(appComp.tenantContent)">
                                                            <a [href]="getPrivacyPolicy(appComp.tenantContent)"
                                                                target="_blank">Lenovo Privacy
                                                                Policy</a></ng-container>
                                                        You may unsubscribe anytime using the link in each email
                                                        communication.
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <button type="submit"
                                                    class="submit-but call-store-but">{{"store-listing.submit" |
                                                    translate}}</button>
                                            </li>
                                        </ul>
                                    </form>

                                </div>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div *ngIf="
                                    storeDetails?.FeaturedProducts &&
                                    storeDetails?.FeaturedProducts.length > 0
                                " id="featuredProductsPlaceHolder"></div>
                            <div class="review-bx mb-5">
                                <h2 class="section-title" *ngIf="
                                        storeDetails &&
                                        storeDetails.avg_rating &&
                                        storeDetails.avg_rating.length > 0
                                    ">
                                    Google Business Reviews
                                </h2>
                                <div class="stars" style="
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                    " *ngIf="
                                        storeDetails &&
                                        storeDetails.avg_rating &&
                                        storeDetails.avg_rating.length > 0
                                    ">
                                    <span class="rating">{{
                                        storeDetails.avg_rating
                                        }}</span>
                                    <star-rating style="transform: scale(0.8);" #star2 [value]="getAverageRating()"
                                        [totalstars]="5" class="gmbstars" [className]="'gmbstars'"
                                        checkedcolor="#F2C94C" uncheckedcolor="#9e9e9e" size="24px" [readonly]="true">
                                    </star-rating>
                                </div>
                                <div id="reviewsPlaceHolder" class="bx-wrapper"></div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="
                            storeDetails?.FeaturedProducts &&
                            storeDetails?.FeaturedProducts.length > 0 &&
                            storeDetails &&
                            storeDetails.sellertype &&
                            storeDetails.sellertype == 'Reseller' &&
                            storeDetails?.reviews &&
                            storeDetails?.reviews.length == 0
                        ">
                        <div class="col-md-12">
                            <div class="review-bx mb-5">
                                <h2 class="section-title" *ngIf="
                                        storeDetails &&
                                        storeDetails.avg_rating &&
                                        storeDetails.avg_rating.length > 0
                                    ">
                                    Google Business Reviews
                                </h2>
                                <div class="stars" style="
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                    " *ngIf="
                                        storeDetails &&
                                        storeDetails.avg_rating &&
                                        storeDetails.avg_rating.length > 0
                                    ">
                                    <span class="rating">{{
                                        storeDetails.avg_rating
                                        }}</span>
                                    <star-rating style="transform: scale(0.8);" #star2 [value]="getAverageRating()"
                                        [totalstars]="5" class="gmbstars" [className]="'gmbstars'"
                                        checkedcolor="#F2C94C" uncheckedcolor="#9e9e9e" size="24px" [readonly]="true">
                                    </star-rating>
                                </div>
                                <div id="reviewsPlaceHolder" class="bx-wrapper"></div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="
                            storeDetails?.FeaturedProducts &&
                            storeDetails?.FeaturedProducts.length > 0 &&
                            storeDetails &&
                            storeDetails.sellertype &&
                            storeDetails.sellertype === 'Reseller' &&
                            storeDetails &&
                            storeDetails.avg_rating &&
                            storeDetails.avg_rating.length == 0
                        ">
                        <div class="col-md-12">
                            <div *ngIf="
                                    storeDetails?.FeaturedProducts &&
                                    storeDetails?.FeaturedProducts.length > 0
                                " id="featuredProductsPlaceHolder"></div>
                        </div>
                    </ng-container>
                </div>

                <div class="row clearfix">
                    <div class="col-lg-6 pl-4">
                        <div class="view-offer-bx store-view-offer-bx store-site assistance_placeholder">
                            <h2 class="section-title">
                                {{ "store-listing.section-title-whats-latest" | translate }}
                            </h2>

                            <div #offerGallery [ngClass]="
                                    isDesktop
                                        ? 'offer-gallery p-2 arrow-up'
                                        : 'offer-gallery p-2 arrow-down'
                                " id="offerGallery">
                                <app-offers #whatsLatest *ngIf="isDesktop && desktopBanner" [images]="desktopBanner"
                                    [height]="offersHeight"></app-offers>

                                <app-offers #whatsLatest *ngIf="!isDesktop && banners.length > 0" [images]="banners"
                                    [height]="offersHeight"></app-offers>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 pl-4">
                        <div class="view-offer-bx store-view-offer-bx store-site assistance_placeholder">
                          
                                <app-get-assistance [country]="appComp.countryName"></app-get-assistance>
                           
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-bg-color">
            <div class="about-section" *ngIf="
                    storeDetails?.aboutStore && storeDetails?.aboutStore != '';
                    else tempStoreAbout
                ">
                <div class="container">
                    <h4>
                        {{
                        "store-listing.store-site.about-lenovo.title"
                        | translate
                        }}
                    </h4>
                    <p [innerHTML]="storeDetails.aboutStore"></p>
                </div>
            </div>

            <ng-template #tempStoreAbout>
                <div class="about-section">
                    <div class="container">
                        <h4>
                            {{
                            "store-listing.store-site.about-lenovo.title"
                            | translate
                            }}
                        </h4>
                        <p>
                            Lenovo is a US$43 billion global Fortune 500 company
                            and a leader in providing innovative consumer,
                            commercial, and data center technology. Our
                            portfolio of high-quality, secure products and
                            services covers PCs (including the legendary Think
                            and multimode Yoga brands), workstations, servers,
                            storage, networking, software (including ThinkSystem
                            and ThinkAgile solutions), smart TVs and a family of
                            mobile products like smartphones (including the
                            Motorola brand), tablets and apps.
                        </p>
                    </div>
                </div>
            </ng-template>

            <div class="faqs-section">
                <div class="container py-4">
                    <h4 class="section-title">
                        {{ "store-listing.store-site.faqs.title" | translate }}
                    </h4>
                    <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="ngb-panel-0">
                        <ngb-panel *ngFor="let faq of tenantContent" title="{{ faq.title }}">
                            <ng-template ngbPanelContent>
                                {{ faq.description }}
                            </ng-template>
                        </ngb-panel>
                    </ngb-accordion>
                </div>
            </div>


            <div class="most-search-bx">
                <div class="container">
                    <h4>
                        {{
                        "store-listing.store-site.most-searched.title"
                        | translate
                        }}
                    </h4>
                    <ul class="pl-3 pr-5">
                        Lenovo Exclusive Store | Lenovo Store | Where To Buy
                        Computer | Old Laptop Buy And Sell | Computer Hardware
                        Store | Lenovo Store Locator | Computers & Laptops
                        Accessories | Best Gaming Laptops | Best Laptop Shop |
                        Laptop Store Near Me | Best Buy Laptops | Desktop Store
                        | Laptops And Computer Store | Lenovo Laptop price |
                        Lenovo Service Center | Best Lenovo store | Yoga Laptops
                        | Lenovo Premium Laptops | Best Lenovo Laptop Store |
                        Lenovo Shop Near Me | Lenovo Laptops | Lenovo Laptop
                        Store Near Me | Lenovo Laptop Store | Best Place To Buy
                        Laptop | Where To Buy Laptop | Computer Repair Service |
                        Laptop Repair Store | Buy A Lenovo | Laptop Dealers |
                        Premium Laptops Store | Laptop Shop Near Me | Laptop
                        Deals | Laptops For Sale | Computer Store and Shop |
                        Laptop Store and shop | Where to Buy Lenovo Laptops |
                        Offers on Lenovo Laptops | Legion Laptops | Ideapad
                        Laptops | Lenovo Gaming Laptop | Lenovo Showroom |
                        Lenovo Exclusive Store Near Me
                    </ul>
                </div>
            </div>
        </div>
    </section>
    <!-- content end -->

    <app-footer [sellertype]="isLoggedIn()"></app-footer>

    <!-- call slide section start -->
    <div class="call-slide-section" id="callSlideSection">
        <a href="javascript:;" class="close-call-section"></a>
        <div class="call-section-content">
            <div class="screen-1">
                <span class="txt1">Would you like to talk to someone at
                    <strong>Ace Infocom?</strong></span>
                <a href="tel:1234567890" class="button-white">Call Now</a>
                <span class="txt2">Would you like Ace Infocom to call you back?<br />
                    <a href="javascript:;" class="goto-screen2">Yes, call me back instead</a></span>
            </div>
            <div class="screen-2 call-screens">
                <span class="txt3">Enter your mobile number</span>
                <input type="number" value="" placeholder="Enter 10-digit number" class="mobile-num-input" />
                <a href="javascript:;" class="button-blue goto-screen3">Submit</a>
                <span class="txt2">Our policies do not allow spamming. <br />So be
                    assured.</span>
            </div>
            <div class="screen-3 call-screens">
                <span class="thank-you-icon"></span>
                <span class="txt4">Thank You!</span>
                <span class="txt4">You shall recieve a call from our store in a few
                    minutes.</span>
                <span class="txt2">Our policies do not allow spamming. <br />So be
                    assured.</span>
            </div>
        </div>
    </div>
    <!-- call slide section end -->

    <div #surveyScreen class="survey-screen-bx" id="surveyScreen">
        <a href="javascript:;" class="close-listing-screen closeSurveyScreen" (click)="closeSurveyScreen()"></a>
        <a href="/" class="logo-vertical">
            <img src="./assets/images/lenovo-logo-vert.webp" width="30" height="85" alt="" loading="lazy" />
        </a>
        <div class="survey-screen survey-second-screen h-100 pad-top survey-bg">
            <div class="container">
                <div class="survey-content pt-sm-0">
                    <div class="row justify-content-center">
                        <h4 style="font-weight: 300" class="text-center">
                            You've rated &nbsp;
                            <img style="vertical-align: middle" width="24px" src="../../../../assets/images/emoji{{
                                    rated
                                }}.png" loading="lazy" />
                            &nbsp;
                            <span style="font-weight: 500">
                                {{ ratingString[rated - 1] }}
                            </span>
                            &nbsp;for finding a nearby Lenovo store
                        </h4>
                    </div>

                    <div>
                        <h4 class="text-center">
                            We would like to understand the reasons behind your
                            rating.<br /><span>Select 1 or more reasons.</span>
                        </h4>
                    </div>
                    <div class="check-bx" *ngIf="surveyRatingQuestions.length > 0">
                        <ul class="clearfix">
                            <li *ngFor="
                                    let ques of surveyRatingQuestions;
                                    let i = index
                                ">
                                <div class="check-main">
                                    <input type="checkbox" id="check{{ i + 1 }}" (change)="captureResponse(ques.id)" />
                                    <label for="check{{ i + 1 }}">{{
                                        ques.name
                                        }}</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="survey-content pt-md-5 pt-sm-3">
                        <div>
                            <h4 class="text-center">
                                Based on your experience of finding a nearby
                                store, how likely are you to recommend Lenovo to
                                your family, friends and peers?
                            </h4>
                        </div>
                        <div class="slider-wrapper d-flex flex-column mb-4">
                           
                            <div>
                                <div class="desktop-nps-rating" *ngIf="currentItem1 > 0">
                                    <app-emoji-scale (rateEvent)="onRate1($event)" [ratingLength]="currentItem1"
                                        [ratingString]="ratingString1"></app-emoji-scale>

                                </div>
                            </div>
                           
                        </div>
                       
                    </div>
                   
                    <div class="row justify-content-center">
                        <a href="javascript:;" class="button-gradient1 cta-buy-post"
                            (click)="showSurveyNext(3, $event)">Submit</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="survey-screen thank-you-screen h-100 survey-bg">
            <div class="container h-100">
                <div class="thank-you-cont survey-content text-center">
                    <span class="thank-you-img">
                        <img src="./assets/images/thank-you-img.png" width="100%" height="auto" alt="" loading="lazy" />
                    </span>
                    <p>Thank you!</p>
                    <p>
                        Your feedback is valuable to us and we appreciate you
                        taking the time out to let us know!
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #mymodal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Lenovo</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body cart-popup">
        <div class="text-center">
            <img class="block-center" src="/assets/images/{{ image }}" loading="lazy" />
            {{ popupmessage }}
        </div>
    </div>
</ng-template>
<ng-template #surveyModal let-modal>
    <span (click)="dismissSurvey()" style="
            cursor: pointer;
            position: absolute;
            right: -10px;
            background: rgb(27, 43, 129);
            border-radius: 50%;
            width: 30px;
            height: 30px;
            top: -10px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-weight: 800;
        ">X</span>
    <app-popup-survey [_for]="isDesktop ? 'desktop' : 'mobile'" (selectedOption)="initSurveyFromPopup($event)">
    </app-popup-survey>
</ng-template>


<div id="countries">
    <div mat-dialog-title style="
            float: right;
            font-weight: 700;
            cursor: pointer;
            color: white;
            font-size: 20px;
        " (click)="home.close()">
        X
    </div>
    <div class="popular-cities-bx" *ngIf="appComp.popCities && !this.appComp.countryListShow">
        <p>
            {{ "store-listing.label-popular-cities" | translate }} <br /><a href="javascript:;"
                *ngFor="let city of appComp.popCities" (click)="home.getStoresByCity(city.lat, city.lng, city.city)">{{
                city.city }}</a>
        </p>
    </div>
    <div class="popular-cities-bx" *ngIf="this.appComp.countryListShow">
        <p style="font-weight: 800">
            {{ "store-listing.tab-title-country-region" | translate }} <br /><a class="d-flex align-items-center"
                href="javascript:;" *ngFor="let country of appComp.languages"
                (click)="home.getCountrySelected(country.code, country.name)">
                {{ country.name }}</a>
        </p>
    </div>
</div>